import {
  RefObject,
  useCallback,
} from "react";

import { API_URLS, fetcher } from "@repo/edtech-api";
import { snakize } from "@repo/edtech-shared";

import {
  AnalyticsMutationArgs,
  AnalyticsParent,
  TrackPayload,
} from "./types";

const trigger = async (data: AnalyticsMutationArgs) => {
  return await fetcher({
    url: API_URLS.ANALYTICS,
    method: "GET",
    params: data,
  });
};

export const useAnalyticsTrack = (analyticEventsCache: RefObject<Set<string>>) => {
  return useCallback(async ({
    params,
    dedup = false,
    materialId,
    publicationId,
    unitId,
    parentId,
  }: {
    params: TrackPayload,
    dedup: boolean,
    materialId: string,
    publicationId: string,
    unitId: string,
    parentId: AnalyticsParent,
  }) => {
    const eventKey = `${params.type}-${publicationId}-${unitId}-${materialId}`;

    if (dedup && analyticEventsCache?.current?.has(eventKey)) return;
    analyticEventsCache?.current?.add(eventKey);

    const fullParams: AnalyticsMutationArgs = {
      publicationid: publicationId,
      unitid: unitId ?? "",
      material: materialId,
      parent: parentId,
      ...params,
    };

    return await trigger(snakize(fullParams));

  },
  [ analyticEventsCache ]);

};
